webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/lodash.startcase/index.js
var lodash_startcase = __webpack_require__("peot");
var lodash_startcase_default = /*#__PURE__*/__webpack_require__.n(lodash_startcase);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function table_toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(object["e" /* keys */])(v).map(function (k) {
      return table_toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return table_toString(Object(object["e" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return table_toString(a[sortBy]).localeCompare(table_toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object') {
    field = Object(object["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ var table = ({
  mixins: [mixins["j" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    // Build the caption
    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // Build the thead
    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    // Build the tfoot
    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    // Add static Top Row slot
    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the body rows
    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];
      // For Each Row
      var tds = fields.map(function (field) {
        // Foe Each field in the row
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });
      // Assemble and add the row
      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));
      // Row Details slot
      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot
    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', {}, rows);

    // Return the assembled table
    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          Object(utils["n" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0.beta.10 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(utils["c" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (Object(array["d" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: lodash_startcase_default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(Object(object["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && Object(object["e" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = Object(object["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && typeof_default()(this.fields) === 'object' && Object(object["e" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        Object(object["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        Object(object["e" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: lodash_startcase_default()(k) });
        });
      }
      // Ensure we have a unique array of fields and that they have labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || lodash_startcase_default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: object["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("CrcJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1vrO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VRD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Nka":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/link/link.js
var link_link = __webpack_require__("etPs");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue

//
//
//
//
//
//
//
//
//
//
//






// Props needed for router links
var routerProps = Object(link_link["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var pagination_nav_props = Object(object["a" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);

// Our render function is brought in via the pagination mixin
/* harmony default export */ var pagination_nav = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: pagination_nav_props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : typeof_default()(link)) === 'object') {
        props = Object(object["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ka7/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination_nav,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_nav_pagination_nav = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CrcJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FhoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {
// Template version: 1.2.3
// see http://vuejs-templates.github.io/webpack for documentation.

const path = __webpack_require__("o/zv")

module.exports = {
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.HOST, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false,
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',

    // edit here for nested paths
    assetsPublicPath: './',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: Object({"NODE_ENV":"production"}).npm_config_report
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ var form_input = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["g" /* formSizeMixin */], mixins["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(array["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            // We only allow certain types
            return Object(array["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control',
            // Fix missing width:100% in Bootstrap V4.beta.2
            this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                // this.ariaInvalid is null or false or 'false'
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                // User wants explicit aria-invalid=true
                return 'true';
            }
            // Most likely a string value (which could be 'true')
            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                // Update the model with the current unformated value
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("XSqZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J5V5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button.js
var button_button = __webpack_require__("E8q/");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button-close.js
var button_close = __webpack_require__("NCKu");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/bv-event.class.js
var bv_event_class = __webpack_require__("5mWU");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

// ObserveDom config
var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ var modal = ({
    mixins: [mixins["i" /* idMixin */], mixins["j" /* listenOnRootMixin */]],
    components: { bBtn: button_button["a" /* default */], bBtnClose: button_close["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Modal Header
        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        // Modal Body
        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        // Modal
        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, defineProperty_default()(_ref, 'modal-' + this.size, Boolean(this.size)), defineProperty_default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, defineProperty_default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), defineProperty_default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), defineProperty_default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, defineProperty_default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), defineProperty_default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, defineProperty_default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), defineProperty_default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), defineProperty_default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new bv_event_class["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if (Object(dom["j" /* hasClass */])(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new bv_event_class["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    Object(utils["n" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = Object(utils["f" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(dom["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new bv_event_class["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            Object(dom["s" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new bv_event_class["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === utils["a" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(dom["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(dom["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = Object(dom["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(dom["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(dom["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                Object(dom["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(dom["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(dom["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(dom["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if (Object(dom["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(dom["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(dom["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        Object(dom["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("1vrO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var form_file = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["h" /* formStateMixin */], mixins["c" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        // Form Input
        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        // 'Drop Here' target
        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        // Overlay Labels
        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        // Return rendered custom file input
        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            // Instruct input to capture from camera
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true, // BS4 beta missing this
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            // Boostrap v4.beta doesn't have focus styling for custom file input
            // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
            // So we add a 'focus' class to get around these "bugs"
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                // Add focus styling for custom file input
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                // Wrapped in try in case IE < 11 craps out
                this.$refs.input.value = '';
            } catch (e) {}
            // IE < 11 doesn't support setting input.value to '' or null
            // So we use this little extra hack to reset the value, just in case
            // This also appears to work on modern browsers as well.
            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            // Always emit original event
            this.$emit('change', evt);
            // Check if special `items` prop is available on event (drop mode)
            // Can be disabled by setting no-traverse
            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                promise_default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(array["c" /* from */])(filesArr));
                });
                return;
            }
            // Normal handling
            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }
            // Convert files to array
            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            // Based on http://stackoverflow.com/questions/3590058
            return new promise_default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    // Get file
                    item.file(function (file) {
                        file.$path = path; // Inject $path to file obj
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    // Get folder contents
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        promise_default.a.all(queue).then(function (filesArr) {
                            resolve(Object(array["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("9Nka")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ka7/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 116 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/google-fonts/index.js
var google_fonts = __webpack_require__("zK9y");
var google_fonts_default = /*#__PURE__*/__webpack_require__.n(google_fonts);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/bootstrap/scss/bootstrap.scss
var bootstrap = __webpack_require__("SSNS");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// CONCATENATED MODULE: ./src/assets/i18n/i18n.js
/* harmony default export */ var i18n = ({
  it: {
    message: {
      title: 'Benvenuto su TOK.tv web player'
    }
  },
  en: {
    message: {
      title: 'Welcome to TOK.tv web player'
    }
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-spinner/src/FadeLoader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FadeLoader = ({

  name: 'FadeLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    height: {
      type: String,
      default: '15px'
    },
    width: {
      type: String,
      default: '5px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.height,
        width: this.width,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    ngRadius: function ngRadius() {
      return '-' + this.radius;
    },
    quarter: function quarter() {
      return parseFloat(this.radius) / 2 + parseFloat(this.radius) / 5.5 + 'px';
    },
    ngQuarter: function ngQuarter() {
      return '-' + this.quarter;
    },
    animationStyle1: function animationStyle1() {
      return {
        top: this.radius,
        left: 0,
        animationDelay: '0.12s'
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        top: this.quarter,
        left: this.quarter,
        animationDelay: '0.24s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        top: 0,
        left: this.radius,
        animationDelay: '0.36s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle4: function animationStyle4() {
      return {
        top: this.ngQuarter,
        left: this.quarter,
        animationDelay: '0.48s',
        transform: 'rotate(45deg)'
      };
    },
    animationStyle5: function animationStyle5() {
      return {
        top: this.ngRadius,
        left: 0,
        animationDelay: '0.60s'
      };
    },
    animationStyle6: function animationStyle6() {
      return {
        top: this.ngQuarter,
        left: this.ngQuarter,
        animationDelay: '0.72s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle7: function animationStyle7() {
      return {
        top: 0,
        left: this.ngRadius,
        animationDelay: '0.84s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle8: function animationStyle8() {
      return {
        top: this.quarter,
        left: this.ngQuarter,
        animationDelay: '0.96s',
        transform: 'rotate(45deg)'
      };
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d59b56e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-spinner/src/FadeLoader.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner",style:({position: 'relative', fontSize: 0})},[_c('div',{staticClass:"v-fade v-fade1",style:([_vm.spinnerStyle,_vm.animationStyle1])}),_c('div',{staticClass:"v-fade v-fade2",style:([_vm.spinnerStyle,_vm.animationStyle2])}),_c('div',{staticClass:"v-fade v-fade3",style:([_vm.spinnerStyle,_vm.animationStyle3])}),_c('div',{staticClass:"v-fade v-fade4",style:([_vm.spinnerStyle,_vm.animationStyle4])}),_c('div',{staticClass:"v-fade v-fade5",style:([_vm.spinnerStyle,_vm.animationStyle5])}),_c('div',{staticClass:"v-fade v-fade6",style:([_vm.spinnerStyle,_vm.animationStyle6])}),_c('div',{staticClass:"v-fade v-fade7",style:([_vm.spinnerStyle,_vm.animationStyle7])}),_c('div',{staticClass:"v-fade v-fade8",style:([_vm.spinnerStyle,_vm.animationStyle8])})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_FadeLoader = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-spinner/src/FadeLoader.vue
function injectStyle (ssrContext) {
  __webpack_require__("d6v6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FadeLoader,
  src_FadeLoader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_spinner_src_FadeLoader = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {};
  },

  components: {
    FadeLoader: vue_spinner_src_FadeLoader
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['loading']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03de18ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"enterActiveClass":"animated fadeIn","leaveActiveClass":"animated fadeOut","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"shadow"},[_c('fade-loader',{attrs:{"loading":_vm.loading,"color":'#00acff',"height":'15px',"width":'6px'}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('router-view'),_vm._v(" "),_c('img',{staticClass:"mx-auto d-block Logo mt-3",attrs:{"src":__webpack_require__("Xpd4")}})],1)])],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("pJbA")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/index.js
var dist = __webpack_require__("GDE4");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Highlights.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Highlights = ({
  data: function data() {
    return {
      sliderValue: 0
    };
  },
  mounted: function mounted() {
    this.sliderValue = this.initialHighLight;
  },

  watch: {
    initialHighLight: function initialHighLight() {
      this.sliderValue = this.initialHighLight;
    }
  },
  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['setHighlights']), {
    getVideoIndex: function getVideoIndex(index) {
      return lodash_default.a.find(this.playlist.highlights, { duration: index }).url;
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['highlights', 'initialHighLight', 'playlist']), {
    minutes: function minutes() {
      var minutes = [];
      lodash_default.a.forIn(this.playlist.highlights, function (h) {
        minutes.push(h.duration);
      });
      return minutes;
    }
  }),
  components: {
    vueSlider: dist_default.a
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607ea49a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Highlights.vue
var Highlights_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Highlights"},[_c('div',{staticClass:"Highlights__close",on:{"click":function($event){_vm.setHighlights(false)}}}),_vm._v(" "),_c('div',{staticClass:"Highlights__title"},[_vm._v("How much time do you have?")]),_vm._v(" "),_c('div',{staticClass:"Highlights__time"},[_vm._v(_vm._s(_vm.sliderValue)+" minutes")]),_vm._v(" "),_c('div',{staticClass:"sliderContainer"},[_c('vue-slider',{attrs:{"width":"100%","data":_vm.minutes,"tooltip":"false"},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})],1),_vm._v(" "),_c('div',{staticClass:"Highlights__button"},[_c('button',{on:{"click":function($event){_vm.$emit('playVideo', _vm.getVideoIndex(_vm.sliderValue))}}},[_vm._v("Watch Now")])])])}
var Highlights_staticRenderFns = []
var Highlights_esExports = { render: Highlights_render, staticRenderFns: Highlights_staticRenderFns }
/* harmony default export */ var components_Highlights = (Highlights_esExports);
// CONCATENATED MODULE: ./src/components/Highlights.vue
function Highlights_injectStyle (ssrContext) {
  __webpack_require__("U3MI")
}
var Highlights_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Highlights___vue_template_functional__ = false
/* styles */
var Highlights___vue_styles__ = Highlights_injectStyle
/* scopeId */
var Highlights___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Highlights___vue_module_identifier__ = null
var Highlights_Component = Highlights_normalizeComponent(
  Highlights,
  components_Highlights,
  Highlights___vue_template_functional__,
  Highlights___vue_styles__,
  Highlights___vue_scopeId__,
  Highlights___vue_module_identifier__
)

/* harmony default export */ var src_components_Highlights = (Highlights_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Plays.vue

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Plays = ({
  data: function data() {
    return {
      sliderValue: 1
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['setHighlights', 'setPlays', 'setPlayers', 'setPlaylist'])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['highlights', 'playlist', 'plays', 'players'])),
  components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acdf984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Plays.vue
var Plays_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Plays"},[_c('div',{staticClass:"Plays__close",on:{"click":function($event){_vm.setPlays(false)}}}),_vm._v(" "),_c('div',{staticClass:"Plays__title"},[_vm._v("\n    What do you want to watch?\n  ")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.playlist.plays),function(item){return _c('div',{staticClass:"Plays__item col-12 col-md-6 mb-3",on:{"click":function($event){_vm.$emit('playVideo', item.url)}}},[_c('div',{staticClass:"col-12 Plays__item__btn"},[_vm._v(_vm._s(item.name)+" ("+_vm._s(item.duration)+")")])])}))])}
var Plays_staticRenderFns = []
var Plays_esExports = { render: Plays_render, staticRenderFns: Plays_staticRenderFns }
/* harmony default export */ var components_Plays = (Plays_esExports);
// CONCATENATED MODULE: ./src/components/Plays.vue
function Plays_injectStyle (ssrContext) {
  __webpack_require__("OvJe")
}
var Plays_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Plays___vue_template_functional__ = false
/* styles */
var Plays___vue_styles__ = Plays_injectStyle
/* scopeId */
var Plays___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Plays___vue_module_identifier__ = null
var Plays_Component = Plays_normalizeComponent(
  Plays,
  components_Plays,
  Plays___vue_template_functional__,
  Plays___vue_styles__,
  Plays___vue_scopeId__,
  Plays___vue_module_identifier__
)

/* harmony default export */ var src_components_Plays = (Plays_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Players.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Players = ({
  mixins: [],
  components: {},
  data: function data() {
    return {};
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['setHighlights', 'initialHighLight', 'setPlayers'])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['highlights', 'playlist', 'players']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21518750","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Players.vue
var Players_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlayersContainer"},[_c('div',{staticClass:"PlayersContainer__title"},[_vm._v("Whom do you want to watch?")]),_vm._v(" "),_c('div',{staticClass:"PlayersContainer__close",on:{"click":function($event){_vm.setPlayers(false)}}}),_vm._v(" "),_c('div',{staticClass:"PlayersContainer__slider"},[_c('div',{staticClass:"Players"},_vm._l((_vm.playlist.players),function(item){return _c('div',{staticClass:"Players__item",on:{"click":function($event){_vm.$emit('playVideo', item.url)}}},[_c('div',{staticClass:"Players__item__picture",style:({ backgroundImage: ("url(" + (item.picture)) })}),_vm._v(" "),_c('div',{staticClass:"Players__item__name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"Players__item__duration"},[_vm._v("("+_vm._s(item.duration)+")")])])}))])])}
var Players_staticRenderFns = []
var Players_esExports = { render: Players_render, staticRenderFns: Players_staticRenderFns }
/* harmony default export */ var components_Players = (Players_esExports);
// CONCATENATED MODULE: ./src/components/Players.vue
function Players_injectStyle (ssrContext) {
  __webpack_require__("J5V5")
}
var Players_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Players___vue_template_functional__ = false
/* styles */
var Players___vue_styles__ = Players_injectStyle
/* scopeId */
var Players___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Players___vue_module_identifier__ = null
var Players_Component = Players_normalizeComponent(
  Players,
  components_Players,
  Players___vue_template_functional__,
  Players___vue_styles__,
  Players___vue_scopeId__,
  Players___vue_module_identifier__
)

/* harmony default export */ var src_components_Players = (Players_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PlayerMenu.vue

//
//
//
//
//
//
//



/* harmony default export */ var PlayerMenu = ({
  name: 'PlayerMenu',
  data: function data() {
    return {};
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapMutations */])(['setHighlights', 'setPlays', 'setPlayers'])),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['highlights', 'plays', 'players']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417ee63d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlayerMenu.vue
var PlayerMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlayerMenu"},[_c('div',{staticClass:"PlayerMenu__item",class:{'active': _vm.highlights},on:{"click":function($event){_vm.setHighlights(true)}}},[_vm._v("Highlights")]),_vm._v(" "),_c('div',{staticClass:"PlayerMenu__item",class:{'active': _vm.plays},on:{"click":function($event){_vm.setPlays(true)}}},[_vm._v("Plays")]),_vm._v(" "),_c('div',{staticClass:"PlayerMenu__item",class:{'active': _vm.players},on:{"click":function($event){_vm.setPlayers(true)}}},[_vm._v("Players")])])}
var PlayerMenu_staticRenderFns = []
var PlayerMenu_esExports = { render: PlayerMenu_render, staticRenderFns: PlayerMenu_staticRenderFns }
/* harmony default export */ var components_PlayerMenu = (PlayerMenu_esExports);
// CONCATENATED MODULE: ./src/components/PlayerMenu.vue
function PlayerMenu_injectStyle (ssrContext) {
  __webpack_require__("pA5J")
}
var PlayerMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PlayerMenu___vue_template_functional__ = false
/* styles */
var PlayerMenu___vue_styles__ = PlayerMenu_injectStyle
/* scopeId */
var PlayerMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PlayerMenu___vue_module_identifier__ = null
var PlayerMenu_Component = PlayerMenu_normalizeComponent(
  PlayerMenu,
  components_PlayerMenu,
  PlayerMenu___vue_template_functional__,
  PlayerMenu___vue_styles__,
  PlayerMenu___vue_scopeId__,
  PlayerMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_PlayerMenu = (PlayerMenu_Component.exports);

// EXTERNAL MODULE: ./src/assets/css/toktv.skin.css
var toktv_skin = __webpack_require__("r5iA");
var toktv_skin_default = /*#__PURE__*/__webpack_require__.n(toktv_skin);

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("FhoZ");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Player.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var Player = ({
  name: 'Player',
  data: function data() {
    return {
      sliderValue: 0,
      playerMenu: true,
      playerSize: {
        height: 0,
        width: 0
      }
    };
  },

  methods: extends_default()({
    handleResize: function handleResize() {
      this.setPlayerHeight();
    }
  }, Object(vuex_esm["b" /* mapMutations */])(['setHighlights', 'setInitialHighLight', 'setPlays', 'setPlayers', 'setPlaylist', 'appReady']), {
    setPlayerHeight: function setPlayerHeight() {
      this.playerSize.width = document.querySelector('.playerContainer').offsetWidth;
      this.playerSize.height = Math.round(this.playerSize.width / 16 * 9);
    },
    playVideo: function playVideo(url) {
      var _this = this;

      clearInterval(window.menuInterval);
      this.setMenuInterval();
      this.setHighlights(false);
      window.jwplayer('player').setup({
        file: url,
        autostart: true,
        width: '100%',
        aspectratio: '16:9',
        stretching: 'exactfit',
        skin: {
          name: 'toktv'
        }
      });
      window.jwplayer('player').on('ready', function () {
        jquery_default()('.jw-slider-time').insertAfter('.jw-icon-playback');
      });
      window.jwplayer('player').on('complete', function () {
        window.jwplayer('player').remove();
        _this.playerMenu = true;
      });
    },
    closeHighlights: function closeHighlights() {
      this.highlights = false;
    },
    setMenuInterval: function setMenuInterval() {
      var _this2 = this;

      window.menuInterval = setInterval(function () {
        if (!_this2.anyPanel && _this2.playerMenu) {
          _this2.playerMenu = false;
        }
      }, 3000);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    var self = this;
    this.setPlayerHeight();
    axios_default.a.get(config_0["build"].assetsPublicPath + 'static/endpoint.json').then(function (config) {
      axios_default.a.get(config.data.endpoint).then(function (response) {
        var initialHighlight = parseInt(lodash_default.a.find(response.data.highlights, {
          default: true
        }).name, 10);

        self.setPlaylist(response.data);
        self.setInitialHighLight(initialHighlight);
      }).then(function () {
        var img = new Image();
        img.src = self.playlist.cover;
        img.addEventListener('load', function () {
          self.appReady();
        }, false);
      });
      // .catch((error) => {
      //   console.warn(error);
      // });
      window.addEventListener('resize', _this3.handleResize);
      _this3.setMenuInterval();
      jquery_default()('.playerContainer').mousemove(function () {
        if (!_this3.playerMenu) {
          _this3.playerMenu = true;
          clearInterval(window.menuInterval);
          _this3.setMenuInterval();
        }
      });
    });
  },

  components: {
    Highlights: src_components_Highlights,
    PlayerMenu: src_components_PlayerMenu,
    Plays: src_components_Plays,
    Players: src_components_Players
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])(['player', 'highlights', 'playlist', 'plays', 'players']), {
    anyPanel: function anyPanel() {
      return this.plays || this.players || this.highlights;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f693062","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
var Player_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainWrapper"},[_c('div',{staticClass:"playerContainer",style:({backgroundImage: ("url(" + (_vm.playlist.cover) + ")"), height:((_vm.playerSize.height) + "px")})},[_c('transition',{attrs:{"enterActiveClass":"animated fadeIn","leaveActiveClass":"animated fadeOut","appear":""}},[(_vm.playerMenu)?_c('PlayerMenu'):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"enterActiveClass":"animated fadeIn","leaveActiveClass":"animated fadeOut","appear":""}},[_c('div',{attrs:{"id":"player"}})])],1),_vm._v(" "),_c('transition',{attrs:{"enterActiveClass":"animated fadeInUp","leaveActiveClass":"animated fadeOutDown","appear":"","mode":"out-in"}},[(_vm.highlights)?_c('Highlights',{on:{"playVideo":function($event){_vm.playVideo($event)}}}):_vm._e(),_vm._v(" "),(_vm.plays)?_c('Plays',{on:{"playVideo":function($event){_vm.playVideo($event)}}}):_vm._e(),_vm._v(" "),(_vm.players)?_c('Players',{on:{"playVideo":function($event){_vm.playVideo($event)}}}):_vm._e()],1)],1)}
var Player_staticRenderFns = []
var Player_esExports = { render: Player_render, staticRenderFns: Player_staticRenderFns }
/* harmony default export */ var components_Player = (Player_esExports);
// CONCATENATED MODULE: ./src/components/Player.vue
function Player_injectStyle (ssrContext) {
  __webpack_require__("b7+c")
}
var Player_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Player___vue_template_functional__ = false
/* styles */
var Player___vue_styles__ = Player_injectStyle
/* scopeId */
var Player___vue_scopeId__ = "data-v-1f693062"
/* moduleIdentifier (server only) */
var Player___vue_module_identifier__ = null
var Player_Component = Player_normalizeComponent(
  Player,
  components_Player,
  Player___vue_template_functional__,
  Player___vue_styles__,
  Player___vue_scopeId__,
  Player___vue_module_identifier__
)

/* harmony default export */ var src_components_Player = (Player_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Player',
    component: src_components_Player
  }]
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint no-param-reassign: ["error", { "props": false }] */
















google_fonts_default.a.add({
  Roboto: ['400', '500']
});

vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
vue_esm["a" /* default */].use(es["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  state: {
    playlist: false,
    initialHighLight: null,
    player: false,
    highlights: true,
    plays: false,
    players: false,
    loading: true
  },
  mutations: {
    appReady: function appReady(state) {
      state.loading = false;
    },
    setPlaylist: function setPlaylist(state, payload) {
      var playlist = payload;

      playlist.highlights = lodash_default.a.map(playlist.highlights, function (hl) {
        hl.duration = parseInt(hl.name, 10);
        return hl;
      });

      state.playlist = playlist;
    },
    setInitialHighLight: function setInitialHighLight(state, payload) {
      state.initialHighLight = payload;
    },
    setHighlights: function setHighlights(state, payload) {
      state.highlights = payload;
      state.plays = false;
      state.players = false;
    },
    setPlays: function setPlays(state, payload) {
      state.plays = payload;
      state.players = false;
      state.highlights = false;
    },
    setPlayers: function setPlayers(state, payload) {
      state.players = payload;
      state.highlights = false;
      state.plays = false;
    },
    setPlayer: function setPlayer(state, payload) {
      state.player = payload;
    }
  }
});

var main_i18n = new vue_i18n_esm["a" /* default */]({
  locale: 'en',
  messages: i18n
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  i18n: main_i18n,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "OvJe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QUmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
//
//
//
//
//
//
//
//
//
//
//





var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ var pagination = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (Object(dom["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
function injectStyle (ssrContext) {
  __webpack_require__("U57Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_pagination = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SSNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SsFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-row.js
var form_row = __webpack_require__("I7Xz");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-text.js
var form_text = __webpack_require__("tDPY");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-invalid-feedback.js
var form_invalid_feedback = __webpack_require__("q32r");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-valid-feedback.js
var form_valid_feedback = __webpack_require__("x7Qz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var form_group = ({
    mixins: [mixins["i" /* idMixin */], mixins["h" /* formStateMixin */]],
    components: { bFormRow: form_row["a" /* default */], bFormText: form_text["a" /* default */], bFormInvalidFeedback: form_invalid_feedback["a" /* default */], bFormValidFeedback: form_valid_feedback["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Label
        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        // Invalid feeback text
        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        // Valid feeback text
        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        // Form help text (description)
        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        // Build layout
        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        // Generate fieldset wrapper
        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(utils["n" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
function injectStyle (ssrContext) {
  __webpack_require__("XGFo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_group,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_group_form_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U3MI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U57Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XGFo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSqZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xpd4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "b7+c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d6v6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pA5J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pJbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress-bar.js
var progress_bar = __webpack_require__("KpFv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var progress = ({
    components: { bProgressBar: progress_bar["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        // These props can be inherited via the child b-progress-bar(s)
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        // This prop is not inherited by child b-progress-bar(s)
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("6VRD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r5iA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.589d8fc2ed5edcb4b55e.js